export default __webpack_public_path__ + "static/media/hht1_ep16_timeline_q01_a.3f4b958c.png";